export const guestUser = {
  isGuest: true,
  isUpgraded: false,
  isActive: true,
  timestamp: new Date().toISOString(),
  account: {
    plan: null,
    customer_id: null,
    plans_id: null,
    uuid: '',
    id: 0,
  },
};
